import React, { Component } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { getToken } from '../keycloak'; // ✅ add this
// ✅ Centralized base URL for the rules service
const RULES_API_BASE =
  process.env.REACT_APP_RULES_API_BASE_URL ||
  "/composite-backend/internal/ui/rules";

class RuleListing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rules: [],
      searchQuery: '',
      sortConfig: { key: '', direction: 'asc' },
    };
  }

  componentDidMount() {
    this.fetchRules();
  }

  fetchRules = () => {
    const token = getToken();
    console.log("[RuleListing] getToken() -> hasToken:", !!token);

    if (!token) {
      console.warn("[RuleListing] No token available; skipping /list-rules call");
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    axios
      .get(`${RULES_API_BASE}/list-rules`, {
        withCredentials: true,
        headers,
      })
      .then((response) => {
        console.log(
          "[RuleListing] /list-rules status:",
          response.status,
          "rows:",
          response.data?.length
        );
        this.setState({ rules: response.data || [] });
      })
      .catch((error) => {
        console.error(
          "❌ [RuleListing] Error fetching rules:",
          error?.response?.status,
          error?.response?.data || error
        );
      });
  };


  handleSearchChange = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  handleEditRule = (ruleName) => {
    window.location.href = `/edit-rule/${ruleName}`;
  };

  handleSort = (key) => {
    const { sortConfig } = this.state;
    const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    this.setState({ sortConfig: { key, direction } });
  };

  getSortedRules = (rules) => {
    const { sortConfig } = this.state;
    if (!sortConfig.key) return rules;

    return [...rules].sort((a, b) => {
      let aValue = a[sortConfig.key] || '';
      let bValue = b[sortConfig.key] || '';

      if (sortConfig.key === 'date_created' || sortConfig.key === 'date_updated') {
        aValue = new Date(aValue);
        bValue = new Date(bValue);
      }

      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  };

    formatTimeAgo = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
  
    const minutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(diffMs / 3600000);
    const days = Math.floor(diffMs / 86400000);
  
    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes} min ago`;
    if (hours < 24) return `${hours} hr${hours > 1 ? 's' : ''} ago`;
    return `${days} day${days > 1 ? 's' : ''} ago`;
  };
  

  render() {
    const { rules, searchQuery, sortConfig } = this.state;

    const filteredRules = rules.filter((rule) =>
      rule.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const sortedRules = this.getSortedRules(filteredRules);

    return (
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#007BFF', padding: '16px', color: '#FFF' }}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img src="/assets/b4d48a3e-5b5a-4392-ab30-df41c0a4471a.jpg" alt="Idenza Logo" style={{ width: '50px', marginRight: '10px' }} />
            <h1 style={{ margin: '0' }}>Idenza</h1>
          </div>
          <h2 style={{ textAlign: 'center', flexGrow: 1 }}>Rules Management</h2>
        </div>

        <div style={{ padding: '24px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
            <input
              type="text"
              placeholder="Search by rule name"
              value={searchQuery}
              onChange={this.handleSearchChange}
              style={{ padding: '8px', width: '300px', borderRadius: '4px', border: '1px solid #D1D5DB' }}
            />
            <Link to="/create-rule" style={{ padding: '10px 16px', backgroundColor: '#007BFF', color: '#FFF', textDecoration: 'none', borderRadius: '4px' }}>
              Manage Rules
            </Link>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
  <thead>
    <tr style={{ backgroundColor: '#f3f4f6' }}>
      <th
        style={{
          border: '1px solid #e5e7eb',
          padding: '12px',
          textAlign: 'left',
          cursor: 'pointer'
        }}
        onClick={() => this.handleSort('name')}
      >
        Name {sortConfig.key === 'name' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
      </th>
      <th
        style={{
          border: '1px solid #e5e7eb',
          padding: '12px',
          textAlign: 'left',
          cursor: 'pointer'
        }}
        onClick={() => this.handleSort('description')}
      >
        Description {sortConfig.key === 'description' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
      </th>
      <th
        style={{
          border: '1px solid #e5e7eb',
          padding: '12px',
          textAlign: 'center',
          cursor: 'pointer'
        }}
        onClick={() => this.handleSort('date_created')}
      >
        Date Created {sortConfig.key === 'date_created' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
      </th>
      <th
        style={{
          border: '1px solid #e5e7eb',
          padding: '12px',
          textAlign: 'center',
          cursor: 'pointer'
        }}
        onClick={() => this.handleSort('date_updated')}
      >
        Date Updated {sortConfig.key === 'date_updated' ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
      </th>
      <th style={{ border: '1px solid #e5e7eb', padding: '12px', textAlign: 'center' }}>Actions</th>
    </tr>
  </thead>

  <tbody>
    {sortedRules.map((rule, index) => (
      <tr
        key={index}
        style={{
          borderBottom: '1px solid #e5e7eb',
          transition: 'background 0.2s ease-in-out'
        }}
        onMouseEnter={e => (e.currentTarget.style.background = '#f9f9f9')}
        onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
      >
        <td style={{ padding: '12px', verticalAlign: 'middle', textAlign: 'left' }}>
          {rule.name}
        </td>
        <td
          style={{
            padding: '12px',
            verticalAlign: 'middle',
            maxWidth: '300px',
            textAlign: 'left'
          }}
        >
          <div className="text-truncate" title={rule.description}>
            {rule.description}
          </div>
        </td>
        <td style={{ padding: '12px', verticalAlign: 'middle', textAlign: 'center' }}>
          {rule.date_created}
        </td>
        <td style={{ padding: '12px', verticalAlign: 'middle', textAlign: 'center' }}>
          {rule.date_updated}
        </td>
        <td style={{ padding: '12px', verticalAlign: 'middle' }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px'
            }}
          >
            <button className="btn btn-sm btn-primary" onClick={() => this.handleEditRule(rule.name)}>
              🖊 Edit
            </button>
            <Link to={`/view-rule/${rule.name}`}>
              <button className="btn btn-sm btn-success">👁 View</button>
            </Link>
          </div>
        </td>
      </tr>
    ))}
  </tbody>
</table>


        </div>
      </div>
    );
  }
}

export default RuleListing;

